module.exports = __webpack_public_path__ + "img/logobg.233a32e8.png";